import { gorselSrcset, KAPAK_SIZES, type SayfaGorsel } from "@/lib/sayfa_gorsel_ortak";

/**
 * Sayfa görseli bileşenleri; veri şablonun kendi modülünden (client/src/lib/sayfa_gorsel_veri/<şablon>.ts), SSR karşılığı
 * server/seo/render.ts sayfaGorselHtml. Şablonlar yalnız kayıt varsa basar, yoksa DOM eskisiyle aynıdır.
 * Bu modül components/EkIcerik.tsx üzerinden ana pakettedir (veri içermez); şablon rotaları için ayrı parça yoktur.
 */

/**
 * Hero sağ sütun kapağı (1200x630, en fazla 400 px). Sütunda yan kutudan SONRA gelir: mobilde yan kutunun altında
 * (ilk ekranın dışında), masaüstünde lg:order-first ile üstünde, yani ilk ekranda ve çoğu sayfada LCP öğesi.
 * Bu yüzden loading="lazy" YOK (varsayılan eager; mobilde de tarayıcının tembel yükleme eşiği içinde kaldığı için
 * zaten hemen yükleniyordu); decoding="async" kalır. fetchPriority ve preload yok: mobilde LCP metin öğesidir.
 * SSR karşılığı server/seo/render.ts sayfaGorselHtml(…, "kapak") aynı nitelikleri basar.
 */
export function HeroKapak({ g }: { g: SayfaGorsel }) {
  return (
    <figure className="order-last lg:order-first w-full max-w-[400px] lg:self-end border-4 border-black bg-white shadow-[6px_6px_0px_0px_rgba(0,0,0,1)]">
      <img
        src={g.src}
        srcSet={gorselSrcset(g.src, g.w)}
        sizes={KAPAK_SIZES}
        width={g.w}
        height={g.h}
        alt={g.alt}
        decoding="async"
        className="block w-full h-auto"
      />
    </figure>
  );
}

/**
 * Bölüm arası görsel (1200x675); blog BlogGovde.tsx Gorsel bileşeniyle aynı görünüm. `className` figure'a gider;
 * space-y kapsayıcısının içinde boş verilir (aralığı kapsayıcı verir).
 */
export function AraGorsel({ g, className = "my-8" }: { g: SayfaGorsel; className?: string }) {
  return (
    <figure className={className || undefined}>
      <img src={g.src} alt={g.alt} width={g.w} height={g.h} loading="lazy" decoding="async" className="w-full h-auto border-4 border-black bg-white" />
      {g.altYazi ? <figcaption className="mt-2 font-mono text-xs font-bold text-black">{g.altYazi}</figcaption> : null}
    </figure>
  );
}

/** Birden fazla ara görsel (sırayla); liste boşsa hiçbir şey basmaz. */
export function AraGorseller({ liste, className }: { liste: SayfaGorsel[]; className?: string }) {
  return (
    <>
      {liste.map(g => (
        <AraGorsel key={g.src} g={g} className={className} />
      ))}
    </>
  );
}
